class ShippingCalculator extends HTMLElement {
  constructor() {
    super();
    this.total = parseInt(this.dataset.totalPrice);
    this.progress = this.querySelector('progress');
    this.progressMessage = this.querySelector('[data-progress-message]');
    this.freeShippingMessage = this.dataset.freeShippingMessage;
    this.delimiterMessage = this.dataset.delimiterMessage;
    this.priceFormat = this.dataset.priceFormat;

    const threshold = this.getThreshold();

    if (threshold !== false) {
      this.initProgress(threshold);
    } else {
      document.addEventListener('threshold:fetched', (event) => {
        this.initProgress(event.detail.threshold);
      });

      document.addEventListener('threshold:error', (event) => {
        this.displayError(event.detail.message);
      });
    }
  }

  getThreshold() {
    return this.dataset.threshold;
  }

  initProgress(threshold) {
    let percentage = 0;
    if (threshold === 0) percentage = 100;
    if (threshold > 0) percentage = (this.total * 100) / (threshold * 100);
    this.progress.setAttribute('value', Math.min(100, percentage));

    if (percentage >= 100) {
      this.progressMessage.innerHTML = this.freeShippingMessage;
      return;
    }

    const amountLeft = (threshold * 100) - this.total;
    this.progressMessage.innerHTML = this.delimiterMessage.replace('[amount]', formatMoney(amountLeft, this.priceFormat));
  }

  displayError(message) {
    console.error(message);
    this.remove();
  }
}

customElements.define('shipping-calculator', ShippingCalculator);